module.exports = __webpack_public_path__ + "img/bg7.bc3fb2fa.jpg";